import React, { useState } from 'react';
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom';
import GoogleLogin from 'react-google-login';
import MicrosoftLogin from "react-microsoft-login";
import Container from '@material-ui/core/Container';
import { makeStyles } from '@material-ui/core';
import FacebookLogin from 'react-facebook-login';
import Typography from '@material-ui/core/Typography';
import { history } from './CustomBrowserRouter'
import { environment } from './common/Environments/environment';

import { getAppInsights } from './TelemetryService';
import TelemetryProvider from './telemetry-provider';

import './App.scss'
import FormPage from './FormPage';
import LandingPage from './LandingPage';
import RoleContainer from './RoleContainer';
import SubmittedPage from './SubmittedPage';
import { AppService } from './common/AppService';

const useStyles = makeStyles(theme => ({
    button: {
        color: 'white !important',
        fontSize: theme.typography.h5.fontSize,
    },

    buttonContainer: {
        display: 'flex',
        justifyContent: 'space-around',
        marginTop: theme.spacing(6),
    },

    header: {
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(3)
    },

    requirementsTable: {
        fontSize: 14
    },

    footNotes: {
        fontSize: 11
    },

    container: {
        backgroundColor: 'white',
        maxWidth: 600,
        minHeight: 600,

        [theme.breakpoints.up('sm')]: {
            padding: theme.spacing(6),
        },

        [theme.breakpoints.down('sm')]: {
            flexGrow: 1,
            padding: theme.spacing(4),
        },

        '& > p,h4': {
            marginBottom: theme.spacing(3),
            textAlign: 'justify',
        },
    },

    roleSelector: {
        marginTop: theme.spacing(4),

        '& > p': {
            textAlign: 'justify',
        },

        [theme.breakpoints.down('xs')]: {
            '& > .MuiFormControl-root': {
                marginTop: theme.spacing(2),
            },
        },

        [theme.breakpoints.up('sm')]: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',

            '& > .MuiFormControl-root': {
                display: 'block',
                width: '100%',
                maxWidth: 500,
                marginLeft: theme.spacing(4),
            },

            '& .MuiInputBase-root': {
                width: '100%',
                maxWidth: 500,
            },
        },
    },

    root: {
        // backgroundColor: theme.palette.background.default,
        flex: 'auto',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
    },

    img: {
        marginBottom: theme.spacing(4),
    },

    btnFacebook: {
        fontSize: 14,
        height: 55,
    },

    btnGoogle: {
        marginTop: 10
    },

    btnMicrosoft: {
        marginTop: 10
    }
}));

const App = () => {

    let appInsights = null;

    const classes = useStyles();
    const [email, setEmail] = useState('');
    const [guestEmail, setGuestEmail] = useState('');
    const appService = new AppService();

    if (!email) {

        const storedUser: any = localStorage.getItem('Alutiiq-PreQualificationPortal/user');
        if (storedUser) {
            const user = JSON.parse(storedUser);
            if (user && user.email) {
                setEmail(user.email);
            }
        }
    }

    const responseFacebook = (response: any) => {
        let user = { email: response.email };
        localStorage.setItem('Alutiiq-PreQualificationPortal/user', JSON.stringify(user));
        setEmail(user.email);
    }

    const responseGoogle = (response: any) => {
        if (response === undefined || response.error) return;

        let user = { email: response.profileObj.email, isGuest: false };
        localStorage.setItem('Alutiiq-PreQualificationPortal/user', JSON.stringify(user));
        setEmail(user.email);
    }

    const responseMicrosoft = (err: any, data: any) => {
        console.log(data);
        console.log(err);
        if (err) return;

        let user = { email: data.authResponseWithAccessToken.idToken.preferredName, isGuest: false };
        localStorage.setItem('Alutiiq-PreQualificationPortal/user', JSON.stringify(user));
        setEmail(user.email);
    };

    const responseGuest = () => {
        // Simple email validation regex
        const emailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
    
        // Check if the guestEmail is not empty and valid
        if (!guestEmail || !emailRegex.test(guestEmail)) {
            alert('Please enter a valid email address.');
            return;
        }
    
        appService.userExists(guestEmail).then((response: any) => {
            if (response.status === 200 && !response.data.IsGuest) {
                alert('This email is already registered. Please use a different authentication method.');
                return;
            }
    
            let user = { email: guestEmail, isGuest: true };
            localStorage.setItem('Alutiiq-PreQualificationPortal/user', JSON.stringify(user));
            setEmail(guestEmail);
        }).catch((error: any) => {
            console.error('Error checking if user exists:', error);
        });
    };

    const logout = () => {
        localStorage.removeItem('Alutiiq-PreQualificationPortal/user');
        setEmail('');
        window.location.reload();
    };

    return (
        /*
          // @ts-ignore */
        email ?
            <BrowserRouter>
                <TelemetryProvider instrumentationKey={environment.instrumentationKey} after={() => { appInsights = getAppInsights() }}>
                    <RoleContainer>
                        <Switch>
                            <Route exact path="/" component={LandingPage} />
                            <Route path="/registration" render={(props: any) => <FormPage logoutFunction={logout} {...props} />} />
                            <Route exact path="/submitted" component={SubmittedPage} />
                            <Redirect to="/" />
                        </Switch>
                    </RoleContainer>
                </TelemetryProvider>
            </BrowserRouter >
            :
            (
                <>
                    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
                        <div className={classes.root + ' has-background-light'}>
                            <Container className={classes.container}>
                                <div style={{ display: 'block', width: '35%', margin: 'auto' }} className={classes.img}>
                                    <img src="/ANC-Final-Logo-Black.gif" height="320" width="170" alt="Alutiiq logo" />
                                </div>
                                <Typography variant="h6" color="primary" align="center" className={classes.header}>
                                    Afognak Native Corporation Due Diligence Portal
                                </Typography>
                                <div style={{ display: 'block', width: '45%', margin: 'auto' }}>
                                    <GoogleLogin
                                        className={classes.btnGoogle}
                                        clientId="388898758749-cu2io3v9qecvm6e9pl6cmgl6k64o1mgb.apps.googleusercontent.com"
                                        buttonText="Sign in with Google"
                                        onSuccess={responseGoogle}
                                        onFailure={responseGoogle}
                                    />
                                    <MicrosoftLogin clientId="57b502e7-9b56-4b97-8a36-021d86bade0d"
                                        className={classes.btnMicrosoft}
                                        forceRedirectStrategy={true}
                                        redirectUri={environment.dueDiligenceUrl}
                                        authCallback={responseMicrosoft} />
                                    <br/><br/>
                                    <input
                                        type="email"
                                        placeholder="Enter your email"
                                        value={guestEmail}
                                        onChange={(e) => setGuestEmail(e.target.value)}
                                        style={{ marginTop: 10, width: '95%' }}
                                    />
                                    <button
                                        onClick={responseGuest}
                                        style={{ marginTop: 10, width: '95%' }}
                                    >
                                        Login as Guest*
                                    </button>
                                </div>
                                <div className="is-size-7" style={{ marginTop: '2rem', padding: '.5rem', textAlign: 'center' }}>
                                    *Guest login: Data is not persistent across sessions or browsers and will be lost if browser cache is cleared. Complete the form in one session for consistency.
                                </div>
                            </Container>
                        </div>
                        <div className="has-background-light is-size-7" style={{ padding: '1.5rem', textAlign: 'center' }}>
                            If you have questions about this application or its processing, please contact the Alutiiq Due Diligence Team at <a href="mailto:duediligence@alutiiq.com">DueDiligence@alutiiq.com</a> | <a href="https://privacy.afognak.com/" target="_blank">Privacy Statement</a> | <a href="https://privacy.afognak.com/california-consumer-privacy-act-ccpa-notice-at-collection/" target="_blank">CCPA Collection Notice</a>
                        </div>
                    </div>
                </>
            )
    );
}


export default App;
